import React, { useEffect, useState } from "react";
import { Routes, Route } from "react-router-dom";

//COMPONENTS
import UserProfiles from "./files/userProfiles";
import ProfileSettings from "./files/profileSettings";

function PodRouter() {
    const [isLoaded, setIsLoaded] = useState(false);

    useEffect(() => {
        setIsLoaded(true);
    });

    return (
        <div style={{ height: "100%" }}>
            {isLoaded && (
                <div style={{ height: "100%" }}>
                    <Routes>
                        <Route path="/" element={<UserProfiles />} />
                        <Route path="/profileSettings/:id" element={<ProfileSettings />} />
                    </Routes>
                </div>
            )}
        </div>
    );
}

export default PodRouter;
